export const getBillingQuery = (params) => {
    return `query{
        billing{
          customerAccount{
            negotiatedAmount
            accountNumber
            demoAccount
            numUnits
            trialEndDate
            trialStartDate
            nextBillingDate
            smsBalance
            subscriptionBalance
            accountNumberSms
            accountNumberSubscription
            lowSmsBalanceReminder
            smsReminderThreshold
            subscriptionCost
            accountPlan
            lastSmsPaymentDate
            negotiatedPaymentDeadline
            hasActiveCardSubscription
            monthlySubscriptionCost
            annualSubscriptionCost
            quarterlySubscriptionCost
            quarterlyDiscountPercentage
            annualDiscountPercentage
            paymentSchedule
          }
          constants{
            name
            value
          }
        }
    }`;
}

export const updateSMSAlertPrefereneces = (lowSmsBalanceReminder, smsReminderThreshold) => {
  return `
  mutation{
    updateSmsAlertPreferences(lowSmsBalanceReminder: ${lowSmsBalanceReminder}, smsReminderThreshold: ${smsReminderThreshold}){
      customerAccount{
            accountNumber
            demoAccount
            numUnits
            trialEndDate
            trialStartDate
            nextBillingDate
            smsBalance
            subscriptionBalance
            accountNumberSms
            accountNumberSubscription
            lowSmsBalanceReminder
            smsReminderThreshold
            subscriptionCost
            accountPlan
            negotiatedPaymentDeadline
            hasActiveCardSubscription
            }
    }
  }`
}

export const updateBillingPlan = (payload) => {
  const { newSchedule } = payload;

  const mutation = `mutation{
    updateBillingPlan(newSchedule: "${newSchedule}"){
      success
      message
      customerAccount{
        negotiatedAmount
        accountNumber
        demoAccount
        numUnits
        trialEndDate
        trialStartDate
        nextBillingDate
        lastSmsPaymentDate
        smsBalance
        subscriptionBalance
        accountNumberSms
        accountNumberSubscription
        lowSmsBalanceReminder
        smsReminderThreshold
        subscriptionCost
        accountPlan
        negotiatedPaymentDeadline
        hasActiveCardSubscription
        monthlySubscriptionCost
        annualSubscriptionCost
        quarterlySubscriptionCost
        quarterlyDiscountPercentage
        annualDiscountPercentage
        paymentSchedule
      }
  }}`;
  return mutation;
}